import script from "./DonateSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./DonateSummary.vue?vue&type=script&setup=true&lang=ts"

import "./DonateSummary.vue?vue&type=style&index=0&id=1233c6a7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1233c6a7"]])

export default __exports__